import { createPromiseAction } from 'redux-saga-promise-actions';
import { Calendar, CalendarPayload, CalendarFailure } from 'store/types/calendar';

export const getCalendar = createPromiseAction('GET_CALENDAR_TRIPS', 'GET_CALENDAR_SUCCEEDED', 'GET_CALENDAR_FAILURE')<
  CalendarPayload,
  Array<Calendar>,
  CalendarFailure
>();
